module.exports = __webpack_public_path__ + "static/img/21.a8ec7d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/21.jpg
// module id = L0Yd
// module chunks = 0